import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"
import {
    downLoadCarTemplateFile,
    exportCarXLXS
} from '../../../api/config/modules/VehicleFiles'
import moment from "moment";
export default {
    name: 'VehicleFiles',
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                brandId: '',
                brandTypeId: '',
                FactoryTime: [],
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.search.whole')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            },
            {
                value: '5',
                label: this.$t('common.registrationCode')
            }],
            BrandList: [{
                id: '',
                name: this.$t('common.search.whole')
            }],
            typeList: [{
                id: '',
                name: this.$t('common.search.whole')
            }],
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [{
                prop: "carId",
                label: this.$t('common.carId'),
                align: "center",
                width: "120px"
            },
            {
                prop: "manufactureNum",
                label: this.$t('common.manufactureNum'),
                align: "center",
                width: "150px"
            },
            {
                prop: "carExpiresNum",
                label: this.$t('common.registrationCode'),
                align: "center",
                width: "150px"
            },
            {
                prop: "customNum",
                label: this.$t('common.customNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "plateNum",
                label: this.$t('common.plateNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "terminalId",
                label: this.$t('common.terminalId'),
                align: "center",
                width: "160px"
            },
            {
                prop: "terminalDate",
                label: this.$t('VehicleManagement.terminalBindDate'),
                align: "center",
                width: "160px"
            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",
                width: "120px"
            },
            {
                prop: "brandName",
                label: this.$t('common.brand'),
                align: "center",
                width: "140px"
            },
            {
                prop: "brandTypeName",
                label: this.$t('common.model'),
                align: "center",
                width: "140px"
            },
            {
                prop: "type",
                label: this.$t('VehicleManagement.powerType'),
                align: "center",
                width: "120px"
            },
            {
                prop: "capacity",
                label: this.$t('VehicleManagement.capacity'),
                align: "center",
                width: "120px"
            },
            {
                prop: "deliveryTime",
                label: this.$t('VehicleManagement.deliveryTime'),
                align: "center",
                width: "160px"
            },
            {
                prop: "abutmentState",
                label: this.$t('VehicleManagement.syncState'),
                align: "center",
                width: "160px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.abutmentState === '' ? '' : params.row.abutmentState === 0 ? 'info' : params.row.abutmentState === 1 ? 'danger' : 'success' }
                    }, params.row.abutmentState === '' ? '' : params.row.abutmentState === 0 ? this.$t('VehicleManagement.noSync') : params.row.abutmentState === 1 ? this.$t('VehicleManagement.fail') : this.$t('VehicleManagement.success'))
                }
            },
            {
                prop: "remarks",
                label: this.$t('common.remarks'),
                align: "center",
                width: "160px"
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
            typeList: [],
            dialogFormVisible: false,
            formLabelWidth: '112px',
            diaTitle: '',
            btnType: '',
            rules: {
                carId: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.imputCarid'),
                    trigger: 'blur'
                }],
                manufactureNum: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.manufactureNum'),
                    trigger: 'blur'
                }],
                brandId: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.brandId'),
                    trigger: 'change'
                }],
                brandTypeId: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.brandTypeId'),
                    trigger: 'change'
                }],
                type: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.type'),
                    trigger: 'change'
                }],
                capacity: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.capacity'),
                    trigger: 'change'
                }],
                deliveryTime: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.deliveryTime'),
                    trigger: 'change'
                }],
                carEmissionId: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.carEmissionId'),
                    trigger: 'change'
                }]
            },
            form: {
                carId: '',
                customNum: '',
                motorNum: '',
                plateNum: '',
                manufactureNum: '',
                carSaveAddress: '',
                brandId: '',
                brandTypeId: '',
                type: '',
                capacity: '',
                deliveryTime: '',
                carEmissionId: '',
                remarks: '',

                sizeLength: '',
                sizeWidth: '',
                sizeHeight: '',
                sizeForkLength: '',
                sizePortalNum: '',
                sizeMaxLiftHeight: '',
                sizeClipRange: '',

                isMaintain: '0',
                maintainReminder: '',
                maintainCycle: '',
                safeList: ''
            },
            carEmissionIdList: [],
            disabled: false,
            dialogTransferFormVisible: false,
            LabelWidth: '104px',
            TransferRules: {},
            TransferForm: {
                carId: '',
                roleId: ''
            },
            BindRules: {},
            BindForm: {
                carId: '',
                terminalId: ''
            },
            selected: [],
            id: '',
            name: '',
            dialogBatchFormVisible: false,
            dialogBindFormVisible: false,
            ChangeForm: {
                carId: '',
                terminalId: '',
                newTerminalId: ''
            },
            ChangeRules: {},
            dialogChangeFormVisible: false,
            // ChangeCarForm: {
            //     carId: '',
            //     newCarId: ''
            // },
            // ChangeCarRules: {},
            // dialogCarFormVisible: false,
            checkAll: false,
            checkedCities: [],
            parts: [],
            isIndeterminate: false,
            isShow: true,
        }
    },
    created() {
        this.getBrand()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getAllCar()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllCar()
        },
        getAllCar() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.FactoryTime) {
                if (this.formInline.FactoryTime.length > 0) {
                    startTime = this.formInline.FactoryTime[0]
                    endTime = this.formInline.FactoryTime[1]
                }
            }
            let param = {
                companyId: sessionStorage.getItem("companyId"),
                orgId: this.id,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                brandId: this.formInline.brandId,
                brandTypeId: this.formInline.brandTypeId,
                terminalId: this.formInline.terminalId,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('VehicleFiles/GET_SELECTALLCAR', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        res.data.data.list.map(item => {
                            let itemList = JSON.stringify(item.safeList)
                            let result = itemList.replace(/""/g, "null")
                            item.safeList = JSON.parse(result)
                        })
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getBrand() {
            this.BrandList = [{
                id: '',
                name: this.$t('common.search.whole')
            }]
            this.$store.dispatch('dictionaryManagement/GET_SELECTALLBRAND', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.BrandList = this.BrandList.concat(res.data.data)
                    }
                }
            }).catch(err => { })
        },
        getPart() {
            this.$store.dispatch('DictionaryManaged/GET_SELECTREPAIRTYPE', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.parts = res.data.data
                    }
                }
            }).catch(err => { })
        },
        indexSelect(type) {
            let brandId;
            if (type == 'query') {
                brandId = this.formInline.brandId
            } else {
                brandId = this.form.brandId
            }
            this.typeList = [{
                id: '',
                name: this.$t('common.search.whole')
            }]
            let param = {
                brandId: brandId,
            }
            this.$store.dispatch('dictionaryManagement/GET_SELECTALLTYPE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.typeList = this.typeList.concat(res.data.data.list)

                    }
                }
            }).catch(err => { })
        },
        getCarEmissionId() {
            let param = {
                id: '7'
            }
            this.$store.dispatch('DictionaryManaged/GET_GETDICTVALUE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.carEmissionIdList = res.data.data.list
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllCar()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                brandId: '',
                brandTypeId: '',
                FactoryTime: [],
            }
            this.getAllCar()
        },
        addCar() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.disabled = false
            this.form.deliveryTime = moment().format("YYYY-MM-DD")
            this.getBrand()
            this.getPart()
            this.getCarEmissionId()
            this.generate()
            this.$nextTick(() => {
                this.form.safeList = ''
                this.checkedCities = []
                this.checkAll = false
                this.$refs.form.resetFields()
            })
        },
        editCar() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.disabled = true
            this.checkedCities = []
            let checkedCount = this.checkedCities.length;
            this.checkAll = checkedCount === this.parts.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.parts.length;
            this.getBrand()
            this.getPart()
            this.getCarEmissionId()
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.carId = this.selected[0].carId
                this.form.customNum = this.selected[0].customNum
                this.form.motorNum = this.selected[0].motorNum
                this.form.plateNum = this.selected[0].plateNum
                this.form.carExpiresNum = this.selected[0].carExpiresNum
                this.form.carSaveAddress = this.selected[0].carSaveAddress
                this.form.manufactureNum = this.selected[0].manufactureNum
                this.form.brandId = Number(this.selected[0].brandId)
                this.indexSelect('add')
                this.form.brandTypeId = Number(this.selected[0].brandTypeId)
                this.form.type = this.selected[0].type
                this.form.capacity = this.selected[0].capacity
                this.form.carEmissionId = Number(this.selected[0].carEmissionId)
                this.form.deliveryTime = this.selected[0].deliveryTime
                this.form.remarks = this.selected[0].remarks
                this.form.sizeLength = this.selected[0].sizeLength
                this.form.sizeWidth = this.selected[0].sizeWidth
                this.form.sizeHeight = this.selected[0].sizeHeight
                this.form.sizeForkLength = this.selected[0].sizeForkLength
                this.form.sizePortalNum = this.selected[0].sizePortalNum
                this.form.sizeMaxLiftHeight = this.selected[0].sizeMaxLiftHeight
                this.form.sizeClipRange = this.selected[0].sizeClipRange
                this.form.isMaintain = String(this.selected[0].isMaintain)
                this.form.maintainReminder = this.selected[0].maintainReminder
                this.form.maintainCycle = this.selected[0].maintainCycle
                this.form.safeList = this.selected[0].safeList
                this.checkedCities = this.selected[0].safeList && this.selected[0].safeList.split(',')
                let checkedCount = this.checkedCities.length;
                this.checkAll = checkedCount === this.parts.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.parts.length;

            })
        },
        Relieve() {
            this.$confirm(`${this.$t('common.btn.bindText')}`, `${this.$t('common.btn.hint')}`, {
                cancelButtonText: `${this.$t('common.btn.cancel')}`,
                confirmButtonText: `${this.$t('common.btn.confirm')}`,
                type: 'warning'
            }).then(res => {
                let param = {
                    type: 0,
                    terminalId: '',
                    carId: this.selected[0].carId
                };
                this.$store.dispatch('VehicleFiles/GET_CARBIND', param).then(response => {
                    if (response.data.code == 200) {
                        this.dialogBindFormVisible = false;
                        this.getAllCar();
                        this.$message.success(this.$t('common.btn.unBindSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        companyId: sessionStorage.getItem("companyId"),
                        orgId: this.id,
                        carId: this.form.carId,
                        customNum: this.form.customNum,
                        motorNum: this.form.motorNum,
                        plateNum: this.form.plateNum,
                        carExpiresNum: this.form.carExpiresNum,
                        carSaveAddress: this.form.carSaveAddress,
                        manufactureNum: this.form.manufactureNum,
                        brandId: this.form.brandId,
                        brandTypeId: this.form.brandTypeId,
                        type: this.form.type,
                        capacity: this.form.capacity,
                        carEmissionId: this.form.carEmissionId,
                        deliveryTime: this.form.deliveryTime,
                        remarks: this.form.remarks,
                        sizeLength: this.form.sizeLength,
                        sizeWidth: this.form.sizeWidth,
                        sizeHeight: this.form.sizeHeight,
                        sizeForkLength: this.form.sizeForkLength,
                        sizePortalNum: this.form.sizePortalNum,
                        sizeMaxLiftHeight: this.form.sizeMaxLiftHeight,
                        sizeClipRange: this.form.sizeClipRange,
                        isMaintain: this.form.isMaintain,
                        maintainReminder: this.form.maintainReminder,
                        maintainCycle: this.form.maintainCycle,
                        safeList: this.form.safeList
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('VehicleFiles/GET_INSERTCAR', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllCar();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        this.$store.dispatch('VehicleFiles/GET_UPDATECAR', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllCar();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }


                } else {
                    return false;
                }
            });
        },
        handleCheckAllChange(val) {
            let arr = []
            this.parts.map(item => {
                console.log(item)
                arr.push(item.dictValue)
            })
            this.checkedCities = val ? arr : [];
            this.isIndeterminate = false;
            this.form.safeList = this.checkedCities.join(',')
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.parts.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.parts.length;
            this.form.safeList = this.checkedCities.join(',')
        },
        generate() {
            this.$store.dispatch('VehicleFiles/GET_GETCARID', {}).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                       this.form.carId = res.data.data
                    }
                }
            }).catch(err => { })
        },

        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                carId: '',
                customNum: '',
                motorNum: '',
                plateNum: '',
                carExpiresNum: '',
                manufactureNum: '',
                carSaveAddress: '',
                brandId: '',
                brandTypeId: '',
                type: '',
                capacity: '',
                deliveryTime: '',
                carEmissionId: '',
                remarks: '',
                sizeLength: '',
                sizeWidth: '',
                sizeHeight: '',
                sizeForkLength: '',
                sizePortalNum: '',
                sizeMaxLiftHeight: '',
                sizeClipRange: '',
                isMaintain: '0',
                maintainReminder: '',
                maintainCycle: '',
                safeList: ''
            }
        },
        closeDia() {
            this.form = {
                carId: '',
                customNum: '',
                motorNum: '',
                plateNum: '',
                carExpiresNum: '',
                manufactureNum: '',
                carSaveAddress: '',
                brandId: '',
                brandTypeId: '',
                type: '',
                capacity: '',
                deliveryTime: '',
                carEmissionId: '',
                remarks: '',
                sizeLength: '',
                sizeWidth: '',
                sizeHeight: '',
                sizeForkLength: '',
                sizePortalNum: '',
                sizeMaxLiftHeight: '',
                sizeClipRange: '',
                isMaintain: '0',
                maintainReminder: '',
                maintainCycle: '',
                safeList: ''
            }
            this.dialogFormVisible = false;
        },
        deleteCar() {
            this.$confirm(`${this.$t('common.btn.confirmDelete')}`, `${this.$t('common.btn.delete')}`, {
                cancelButtonText: `${this.$t('common.btn.cancel')}`,
                confirmButtonText: `${this.$t('common.btn.confirm')}`,
                type: 'warning'
            }).then(res => {
                let param = {
                    carIds: this.selected.map(item => item.carId).join()
                }
                this.$store.dispatch('VehicleFiles/GET_DELETECAR', param).then(response => {
                    if (response.data.code == 200) {
                        this.getAllCar()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        downFile(row) {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/FileController/getFile?filePath=${row.filePath}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/FileController/getFile?filePath=${row.filePath}`
                    location.href = url
                }
            }
        },
        transferCar() {
            this.dialogTransferFormVisible = true
            this.TransferForm.carId = ''
            this.selected.map(item => {
                if (this.selected.length > 1) {
                    this.TransferForm.carId = this.TransferForm.carId.concat((item.carId + '-' + item.orgName + ','))
                } else {
                    this.TransferForm.carId = this.TransferForm.carId.concat((item.carId + '-' + item.orgName))
                }
            })
        },
        changeClick(val) {
            this.roleId = val.label
        },
        submitTransferForm(TransferFormName) {
            this.$refs[TransferFormName].validate((valid) => {
                if (valid) {
                    let carIds = ''
                    this.selected.map((item, index) => {
                        if (index == 0) {
                            carIds = item.carId
                        } else {
                            carIds = carIds + ',' + item.carId
                        }
                    })
                    let param = {
                        carIds: carIds,
                        orgId: this.roleId
                    }
                    this.$store.dispatch('VehicleFiles/GET_BATCHCAR', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.transferSuccess'))
                            this.dialogTransferFormVisible = false;
                            this.getAllCar();
                            this.closeTransfer();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })
                } else {
                    return false;
                }
            });
        },
        cancleTransfer(TransferFormName) {
            this.dialogTransferFormVisible = false;
            this.TransferForm = {
                carId: '',
                roleId: ''
            }
        },
        closeTransferDia() {
            this.TransferForm = {
                carId: '',
                roleId: ''
            }
            this.dialogTransferFormVisible = false;
        },
        bindCar() {
            this.dialogBindFormVisible = true;
            this.BindForm.carId = this.selected[0].carId
            this.BindForm.terminalId = this.selected[0].terminalId
            if (this.BindForm.terminalId) {
                this.isShow = true
            } else {
                this.isShow = false
            }
        },
        submitBindForm(BindFormName) {
            this.$refs[BindFormName].validate((valid) => {
                if (valid) {
                    let param = {
                        type: 1,
                        carId: this.BindForm.carId,
                        terminalId: this.BindForm.terminalId
                    }
                    this.$store.dispatch('VehicleFiles/GET_CARBIND', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.bindSuccess'))
                            this.dialogBindFormVisible = false;
                            this.getAllCar();
                            this.closeBind();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })
                } else {
                    return false;
                }
            });
        },
        cancleBind(BindFormName) {
            this.dialogBindFormVisible = false;
            this.BindForm = {
                carId: '',
                terminalId: ''
            }
        },
        closeBindDia() {
            this.BindForm = {
                carId: '',
                terminalId: ''
            }
            this.dialogBindFormVisible = false;
        },
        changeCar() {
            this.dialogChangeFormVisible = true
            this.ChangeForm.carId = this.selected[0].carId
            this.ChangeForm.terminalId = this.selected[0].terminalId
            this.ChangeForm.newTerminalId = ''
        },

        cancleChange(ChangeFormName) {
            this.dialogChangeFormVisible = false;
            this.ChangeForm = {
                carId: '',
                terminalId: '',
                newTerminalId: ''
            }
        },
        closeChangeDia() {
            this.ChangeForm = {
                carId: '',
                terminalId: '',
                newTerminalId: ''
            }
            this.dialogChangeFormVisible = false;
        },
        isTrue() {
            this.dialogChangeFormVisible = false
            this.$confirm(`${this.$t('common.btn.confirmReplace')}`, `${this.$t('common.btn.hint')}`, {
                cancelButtonText: `${this.$t('common.btn.cancel')}`,
                confirmButtonText: `${this.$t('common.btn.confirm')}`,
                type: 'warning'
            }).then(res => {
                let param = {
                    carId: this.ChangeForm.carId,
                    terminalId: this.ChangeForm.terminalId,
                    newTerminalId: this.ChangeForm.newTerminalId
                }
                this.$store.dispatch('VehicleFiles/GET_CARREPLACETERMINAL', param).then(res => {
                    if (res.data.code == 200) {
                        this.closeChangeDia()
                        this.dialogChangeFormVisible = false
                        this.getAllCar()
                        this.$message.success(this.$t('common.btn.replaceSuccess'))
                    } else {
                        this.$message.error(res.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },

        
        BulkImport() {
            this.dialogBatchFormVisible = true
        },
        
        TemplateFile() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportCarModel`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportCarModel`
                    location.href = url
                }
            }
        },
        
        uploadCar(e) {
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            let companyId = sessionStorage.getItem('companyId')
            let userId = sessionStorage.getItem('userId')
            let orgId = this.id
            let formData = new FormData()
            formData.append('File', file)
            formData.append('userId', userId)
            formData.append('companyId', companyId)
            formData.append('orgId', orgId)
            let types = file.name.split('.')[1]
            if (types != "xlsx" && types != "xls") {
                this.$message.error(this.$t('common.btn.choseExcelFile'));
                return false;
            } else {
                this.$store.dispatch('VehicleFiles/GET_UPLOADCAR', formData).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                        this.dialogBatchFormVisible = false;
                        this.getAllCar()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    document.getElementById('uploadDom').value = ''
                }).catch(err => {
                    this.$message.error(this.$t('common.btn.fileUploadError'))
                    document.getElementById('uploadDom').value = ''
                })
            }
        },
        closeBatchDia() {
            this.dialogBatchFormVisible = false
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let startTime = ''
                    let endTime = ''
                    if (this.formInline.factoryDate) {
                        if (this.formInline.factoryDate.length > 0) {
                            startTime = this.formInline.factoryDate[0]
                            endTime = this.formInline.factoryDate[1]
                        }
                    }
                    let companyId = sessionStorage.getItem("companyId")

                    let url = `https://${domainName}/v1/getExportExcel/exportCar?orgId=${this.id}&companyId=${companyId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&terminalId=${this.formInline.terminalId}&brandId=${this.formInline.brandId}&brandTypeId=${this.formInline.brandTypeId}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportCar?orgId=${this.id}&companyId=${companyId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&terminalId=${this.formInline.terminalId}&brandId=${this.formInline.brandId}&brandTypeId=${this.formInline.brandTypeId}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url


                }
            }
        },

        // changeNumber() {
        //     this.dialogCarFormVisible = true
        //     this.$nextTick(() => {
        //         this.ChangeCarForm.carId = this.selected[0].carId
        //         this.ChangeCarForm.newCarId = ''
        //     })
        // },
        // closeCarDia() {
        //     this.dialogCarFormVisible = false
        //     this.ChangeCarForm = {
        //         carId: '',
        //         newCarId: ''
        //     }
        // },
        // cancleCarChange() {
        //     this.dialogCarFormVisible = false
        //     this.ChangeCarForm = {
        //         carId: '',
        //         newCarId: ''
        //     }
        // },
        // submitCarForm(ChangeCarFormName) {
        //     this.$refs[ChangeCarFormName].validate((valid) => {
        //         if (valid) {
        //             let param = {
        //                 carId: this.ChangeCarForm.carId,
        //                 newCarId: this.ChangeCarForm.newCarId
        //             }
        //             this.$store.dispatch('VehicleFiles/GET_UPDATECARID', param).then(res => {
        //                 if (res.data.code == 200) {
        //                     this.$message.success(this.$t('common.btn.editSuccess'))
        //                     this.dialogCarFormVisible = false;
        //                     this.getAllCar();
        //                     this.closeCarDia();
        //                 } else {
        //                     this.$message.error(res.data.msg)
        //                 }

        //             }).catch(err => { })
        //         } else {
        //             return false;
        //         }
        //     });
        // },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllCar();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}